import Button from '@material-ui/core/Button';
import { setKillTrading } from '../../../stores/websocketStore/utils/outgoingMessages/killtrading/setKillTrading';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../stores/websocketStore/websocketProvider';

export const KillTradingButton = observer(({}) => {
  const { killTradingStore } = useWebsocketStore();
  return <KillButton kill={killTradingStore.tradingKilled} />;
});

function KillButton({ kill }) {
  let buttonColor = kill ? 'yellow' : 'red';
  let text = kill ? 'ALLOW TRADING' : 'KILL TRADING';
  return (
    <Button
      variant="contained"
      size="small"
      style={{
        color: 'black',
        backgroundColor: buttonColor,
        height: 30,
        fontSize: 12,
      }}
      onClick={() => setKillTrading(!kill)}
    >
      <b>{text}</b>
    </Button>
  );
}
